module.exports = __webpack_public_path__ + "static/media/Icn-psd.c1be5cb7.svg";